/* eslint-disable prefer-const */
/* eslint-disable react/jsx-props-no-spreading */

import { ProgressIndicator } from "@ctsu/react-ctsu-ui";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { text } from "components/common/Text";
import { Field, Form, Formik } from "formik";
import { useGetUserGroup } from "helpers/getAppConfig";

import React, { useCallback, useState } from "react";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { useFetchCountryListQuery, useFetchStateProvincesQuery } from "stores/apis/apiSlice";
import * as Yup from "yup";

const initialValues = {
  orgId: "",
  siteCtepId: "",
  instName: "",
  zipCode: "",
  cityName: "",
  groupId: "",
  stateName: "",
  userGroup: "",
  newCtepId: "",
  country: "US"
};

export default function AdvanceSearch({
  setSearchtext,
  searchText,
  hasResults,
  searchCriteria,
  queryInstitution,
  isLoading
}) {
  const [isFromValid, setIsFromValid] = useState(false);

  const [formSubmitted, setFormSubmitted] = useState(false);

  const userGroup = useGetUserGroup();

  const FinderSchema = Yup.object({
    siteCtepId: Yup.string(),
    instName: Yup.string(),
    groupId: Yup.string(),
    zipCode: Yup.string(),
    cityName: Yup.string(),
    stateName: Yup.string(),
    newCtepId: Yup.string(),
    userGroup: Yup.string()
  }).test(text("institution.search.error_message"), (value) => {
    setIsFromValid(
      Object.values(value).filter((a) => a !== undefined).length > 0 &&
        (value.siteCtepId ||
          value.instName ||
          value.groupId ||
          value.zipCode ||
          value.stateName ||
          value.country)
    );
  });

  const { data: countryList } = useFetchCountryListQuery();
  const { data: stateName } = useFetchStateProvincesQuery();

  const getStateProvince = useCallback(
    (sectedCountry) => {
      if (sectedCountry && Array.isArray(countryList)) {
        const selectedcountryVal = countryList?.find(
          (c) => c.code === sectedCountry
        );
        if (Array.isArray(stateName)) {
          return stateName?.filter(
            (item) => item.cnyId === selectedcountryVal.value
          );
        }
      }
      return [];
    },
    [countryList, stateName]
  );

  return (
    <Formik
      initialValues={{
        ...initialValues,
        ...searchCriteria
      }}
      enableReinitialize={false}
      validateOnChange
      validationSchema={FinderSchema}
      validateOnBlur
      onSubmit={(values, actions) => {
        const vals = {
          ...values,
          userGroup
        };
        setTimeout(() => {
          actions.setSubmitting(true);
          if (isFromValid) {
            setSearchtext(
              [values.siteCtepId, values.instName]
                .filter((d) => !!d)
                .join(" | ")
            );
            queryInstitution(vals);
            setFormSubmitted(true);
          }
        }, 1000);
      }}
    >
      {(props) => (
        <Form className="container person-finder-wrapper">
          {!isLoading
            ? (
              <p
                className={`m-3 font-btn ${!hasResults && formSubmitted ? "color-red" : ""}`}
              >
                {text("institution.search.your_search_critria")} <span className="font-bold mx-1">{searchText}</span>
                {hasResults
                  ? text("institution.search.matched_multipe_records")
                  : text("institution.search.did_not_match")}
                <span className="mx-1">
                  {text("institution.search.additional_search")}
                </span>
              </p>
            )
            : (
              <p className="mx-3 my-3">
                {text("institution.search.refine_based")}
              </p>
            )}

          <div className="form-layout-wrapper">
            <div className="form-layout-body">
              <div className="row">
                <div className="col-4 mx-2 mt-1">
                  <label className="color-dark-blue" htmlFor="siteCtepId">
                    {text("institution.search.institution_ctep_id")}
                  </label>
                  <div className="form-layout-input">
                    <Field
                      name="siteCtepId"
                      data-testid="siteCtepId"
                      id="siteCtepId"
                      type="text"
                      className="mt-0"
                    />
                  </div>
                </div>
                <div className="col-4 mx-2 mt-1">
                  <label className="color-dark-blue" htmlFor="instName">
                    {text("institution.search.institution_name")}
                  </label>
                  <div className="form-layout-input">
                    <Field
                      name="instName"
                      id="instName"
                      type="text"
                      className="mt-0"
                    />
                  </div>
                </div>
                <div className="col-4 mx-2 mt-1">
                  <label className="color-dark-blue" htmlFor="groupId">
                    {text("institution.search.group_id")}
                  </label>
                  <div className="form-layout-input">
                    <Field
                      name="groupId"
                      id="groupId"
                      type="text"
                      className="mt-0"
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-4 mx-2 mt-1">
                  <label className="color-dark-blue" htmlFor="zipCode">
                    {text("institution.search.zip_code")}
                  </label>
                  <div className="form-layout-input">
                    <Field
                      aria-label={text("institution.search.zip_code")}
                      name="zipCode"
                      id="zipCode"
                      type="text"
                      className="mt-0"
                    />
                  </div>
                </div>
                <div className="col-4 mx-2 mt-1">
                  <label className="color-dark-blue" htmlFor="city">
                    City
                  </label>
                  <Field
                    aria-label="city"
                    name="cityName"
                    id="city"
                    type="text"
                    className="mt-0"
                  >
                    {({ field, form, meta }) => (
                      <>
                        <div className="form-layout-input">
                          <input
                            aria-label="City"
                            type="text"
                            {...field}
                            className="mt-0"
                          />
                        </div>
                        {!isFromValid && meta.touched && (
                          <div className="form-layout-message-disclaimer">
                            {text("institution.search.please_fill_another")}
                          </div>
                        )}
                      </>
                    )}
                  </Field>
                </div>
                <div className="col-4 mx-2 mt-1">
                  <label className="color-dark-blue" htmlFor="state">
                    {text("institution.search.state")}
                  </label>

                  <div className="form-layout-input">
                    {getStateProvince(props.values.country).length > 0
                      ? (
                        <Field id="stateName" name="stateName">
                          {({ field }) => (
                            <div style={{ width: "100%" }}>
                              <CreatableSelect
                                className="reactSelect-wrapper "
                                classNamePrefix="reactSelect"
                                label="stateName"
                                name="stateName"
                                inputId="state"
                                placeholder="Please select an option or type a keyword"
                                formatCreateLabel={(userInput) => `Search for ${userInput}`}
                                options={getStateProvince(props.values.country)}
                                onChange={(option) => {
                                  const newVal = option ? option.value : null;
                                  props.setFieldValue(field.name, newVal);
                                }}
                                isClearable
                              />
                            </div>
                          )}
                        </Field>
                      )
                      : (
                        <Field
                          label="stateName"
                          name="stateName"
                          id="state"
                          placeholder="Please select an option or type a keyword"
                        />
                      )}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-4 ml-2 mt-1 pr-3">
                  <label className="color-dark-blue" htmlFor="country">
                    {text("institution.search.country")}
                  </label>
                  <div className="form-layout-input">
                    <Field id="country" name="country">
                      {({ field }) => (
                        <div style={{ width: "100%" }}>
                          <Select
                            className="reactSelect-wrapper "
                            classNamePrefix="reactSelect"
                            label="country"
                            name="country"
                            inputId="country"
                            value={countryList?.filter(country => country.code === field.value)}
                            options={countryList?.map(c => ({ value: c.code, label: c.label }))}
                            isClearable
                            onChange={option => {
                              if (option) {
                                props.setFieldValue(field.name, option.value);
                              } else {
                                props.setFieldValue(field.name, "");
                              }
                              props.setFieldValue("stateName", "");
                            }}
                          />
                        </div>
                      )}
                    </Field>
                  </div>
                </div>
              </div>
            </div>
            <div className="form-layout-footer">
              <div className="form-layout-actions align-center">
                <button
                  data-testid="btn-submit"
                  className="btn turquoise pl-2"
                  type="submit"
                >
                  <FontAwesomeIcon icon={faSearch} />
                  {text("institution.search.refine")}
                </button>
              </div>
            </div>
          </div>
          {isLoading && <ProgressIndicator />}
        </Form>
      )}
    </Formik>
  );
}
